import { DeepbookSdk } from './deepbook-sdk';
import { turbosSdk } from './turbos-sdk';

export const deepbook = new DeepbookSdk(turbosSdk.network, turbosSdk.provider, 10_000_000);
